import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const PageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 2rem;
  text-align: left;
`;

const PageTitle = styled.h1`
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
`;

const Section = styled.section`
  margin-bottom: 2.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  color: #005eb8;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  list-style-position: inside;
  padding-left: 1rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.li`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 0.5rem;
`;

const PrivacyPolicy = () => {
  return (
    <PageContainer>
      <PageTitle>Privacy Policy</PageTitle>

      <Section>
        <SectionTitle>1. Introduction</SectionTitle>
        <Paragraph>
          The Letter Doctor Ltd ("we", "our", "us") is committed to protecting and respecting your privacy. This policy explains how we collect, use, and safeguard your personal data when you use our website and services.
        </Paragraph>
        <Paragraph>
          We are registered with the Information Commissioner's Office (ICO) under registration number [Your ICO Number]. Our data controller is [Your Data Controller's Name/Position].
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>2. Information We Collect</SectionTitle>
        <Paragraph>We may collect and process the following data about you:</Paragraph>
        <List>
          <ListItem><strong>Personal Identification Information:</strong> Name, date of birth, address, email address, phone number.</ListItem>
          <ListItem><strong>Medical Information:</strong> Details about your health, symptoms, and medical history that you provide in our online questionnaires.</ListItem>
          <ListItem><strong>Payment Information:</strong> Credit/debit card details, which are processed securely by our third-party payment provider (Stripe) and are not stored by us.</ListItem>
          <ListItem><strong>Technical Data:</strong> IP address, browser type, and other technology on the devices you use to access this website.</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>3. How We Use Your Information</SectionTitle>
        <Paragraph>We use the information we collect in the following ways:</Paragraph>
        <List>
          <ListItem>To provide our Services to you, including the review of your medical information by our doctors to issue medical documents.</ListItem>
          <ListItem>To process your payments.</ListItem>
          <ListItem>To communicate with you regarding your request or for customer service purposes.</ListItem>
          <ListItem>To comply with our legal and regulatory obligations.</ListItem>
          <ListItem>To improve our website and services.</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>4. Data Security</SectionTitle>
        <Paragraph>
          We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorised way. All medical information is encrypted and accessible only by our clinical team.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>5. Your Data Protection Rights</SectionTitle>
        <Paragraph>Under data protection law, you have rights including:</Paragraph>
        <List>
          <ListItem><strong>Your right of access</strong> - You have the right to ask us for copies of your personal information.</ListItem>
          <ListItem><strong>Your right to rectification</strong> - You have the right to ask us to rectify information you think is inaccurate.</ListItem>
          <ListItem><strong>Your right to erasure</strong> - You have the right to ask us to erase your personal information in certain circumstances.</ListItem>
          <ListItem><strong>Your right to restriction of processing</strong> - You have the right to ask us to restrict the processing of your information in certain circumstances.</ListItem>
          <ListItem><strong>Your right to data portability</strong> - You have the right to ask that we transfer the information you gave us to another organisation, or to you, in certain circumstances.</ListItem>
        </List>
        <Paragraph>
          To exercise these rights, please <Link to="/contact">contact us</Link>.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>6. Changes to This Policy</SectionTitle>
        <Paragraph>
          We may update this privacy policy from time to time. Any changes will be posted on this page.
        </Paragraph>
        <Paragraph>
          Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
        </Paragraph>
      </Section>
    </PageContainer>
  );
};

export default PrivacyPolicy;